import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Spin } from 'antd';
import { setSelectedFirmaEvrimId } from '../../../redux/users/reducers';

const { Option } = Select;

const Company = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.users.user);

  const firmalar = user?.firma || [];

  const selectedFirmaEvrimId = useSelector(
    state => state.users?.selectedFirmaEvrimId
  );

  const [loading, setLoading] = useState(false);

  const handleChange = selected => {
    setLoading(true);
    const { value } = selected;
    dispatch(setSelectedFirmaEvrimId(value));
    localStorage.setItem('selectedFirmaEvrimId', value);
    setLoading(false);
  };
  useEffect(() => {
    const savedId = localStorage.getItem('selectedFirmaEvrimId');

    if (firmalar.length > 0 && !selectedFirmaEvrimId) {
      const defaultId =
        savedId && firmalar.some(f => f.firmaEvrimId === savedId)
          ? savedId
          : firmalar[0].firmaEvrimId;

      dispatch(setSelectedFirmaEvrimId(defaultId));
      localStorage.setItem('selectedFirmaEvrimId', defaultId);
    }
  }, [firmalar, selectedFirmaEvrimId, dispatch]);

  return (
    firmalar.length > 1 && (
      <div
        style={{
          display: 'flex',
          //alignItems: 'flex-end',
          alignItems: 'center',
          maxWidth: 200,
          marginLeft: 'auto',
          height: 30,
          marginRight: 'auto',
        }}
      >
        <span style={{ fontWeight: 500, color: '#A8AAB3', fontSize: 13 }}>
          Firma:
        </span>
        <Spin spinning={loading}>
          <Select
            labelInValue
            value={{
              value: selectedFirmaEvrimId,
            }}
            onChange={handleChange}
            placeholder="Firma Seçin"
            suffixIcon={null}
            style={{
              width: 200,
              height: 35,
              fontSize: 12,
              borderRadius: 4,
              backgroundColor: '#currentcolor',
              //border: '1px solid #d9d9d9',
              color: '#A8AAB3',
              alignItems: 'center',
              paddingRight: 0,
              paddingLeft: 8,
              lineHeight: '30px',
            }}
            size="small"
            bordered={false}
            dropdownStyle={{ fontSize: 13 }}
          >
            {firmalar.map(firma => (
              <Option key={firma.firmaEvrimId} value={firma.firmaEvrimId}>
                {firma.firmaAdi.length > 15
                  ? firma.firmaAdi.slice(0, 15) + '...'
                  : firma.firmaAdi}
              </Option>
            ))}
          </Select>
        </Spin>
      </div>
    )
  );
};
export default Company;
